import api from "../api";
import config from "../config";

export const NEXT_LAUNCHPAD_TARGETS = Object.freeze({
  STANDARD_LAUNCHPAD: "standard_launchpad",
  PARTNER_REFINEMENTS: "partner_refinements",
});

export const isNextLaunchpadEnabledForUser = ({ user } = {}) => {
  const enabledUserIds = config.nextLaunchpadEnabledUserIds || [];
  const userId = Number(user?.user_id);

  return enabledUserIds.includes(userId);
};

const isPlgAccount = ({ user } = {}) => (
  user?.is_plg_account === true ||
  user?.is_plg_account === 1
);

export const isNextLaunchpadRefinementsEnabledForUser = ({ user } = {}) => {
  const canManageAiReceptionist =
    user?.can_manage_ai_receptionist === true ||
    user?.can_manage_ai_receptionist === 1 ||
    user?.can_manage_ai_receptionist === "1" ||
    user?.can_manage_ai_receptionist === "yes";

  return isPlgAccount({ user }) && canManageAiReceptionist;
};

const canOpenNextLaunchpadTarget = ({ user, target }) => {
  if (target === NEXT_LAUNCHPAD_TARGETS.PARTNER_REFINEMENTS) {
    return isNextLaunchpadRefinementsEnabledForUser({ user });
  }

  return isNextLaunchpadEnabledForUser({ user });
};

const assertAllowedRedirectUrl = ({ redirectUrl }) => {
  const allowedOrigins = config.nextLaunchpadAllowedOrigins || [];
  let parsedUrl;

  try {
    parsedUrl = new URL(redirectUrl);
  } catch {
    throw new Error("Next launchpad handoff returned an invalid redirect URL.");
  }

  if (!["http:", "https:"].includes(parsedUrl.protocol)) {
    throw new Error("Next launchpad handoff returned an invalid redirect URL.");
  }

  if (!allowedOrigins.includes(parsedUrl.origin)) {
    throw new Error("Next launchpad handoff returned an untrusted redirect URL.");
  }
};

export const openNextLaunchpad = async ({
  user,
  target = NEXT_LAUNCHPAD_TARGETS.STANDARD_LAUNCHPAD,
} = {}) => {
  if (!canOpenNextLaunchpadTarget({ user, target })) {
    return;
  }

  const response = await api.user.createNextLaunchpadHandoff({ target });
  const redirectUrl =
    typeof response?.data?.redirect_url === "string"
      ? response.data.redirect_url.trim()
      : "";

  if (!redirectUrl) {
    throw new Error("Next launchpad handoff did not return a redirect URL.");
  }

  assertAllowedRedirectUrl({ redirectUrl });
  window.location.assign(redirectUrl);
};
